<script>
import StatementsCrudListVue from '@/app/modules/contacard/reports/statements/StatementsCrudList.vue';

export default {
  name: 'UserStatementList',
  extends: StatementsCrudListVue,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    hideEdit: true,
    hideDelete: true,
  }),
  computed: {
    clientId() {
      return this.value;
    },
  },
  methods: {
    prepareRequest(params = {}) {
      return this.requestClass.list(
        this.setDefaultParams({
          ClientId: this.clientId,
          ...params,
        }),
      );
    },
  },
};
</script>
